/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbPcs_user" | "PdpSharedBlurbShipping_user" | "PdpSharedBlurbReturns_user" | "PdpSharedBlurbSupportNumber_user">;
    readonly " $refType": "PdpRespSidebarBlurbs_user";
};
export type PdpRespSidebarBlurbs_user$data = PdpRespSidebarBlurbs_user;
export type PdpRespSidebarBlurbs_user$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbReturns_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_user",
      "args": null
    }
  ]
};
(node as any).hash = 'b74628f8f8593d8fb838fad3af4386d8';
export default node;
